export type ImageType = "mechanism_diagram" | "framework_diagram";
export type ImageModel = "nano-banana-pro" | "gpt-image-2";

/** 与 UI 模型选择第一项保持一致 */
export const DEFAULT_IMAGE_MODEL: ImageModel = "gpt-image-2";

export function normalizeImageModel(value?: string | null): ImageModel {
  const normalized = String(value ?? "").trim().toLowerCase();
  if (!normalized) {
    return DEFAULT_IMAGE_MODEL;
  }
  if (
    normalized === "gpt-image-2"
    || normalized === "gpt_image_2"
    || normalized === "gptimage2"
    || normalized === "azure"
  ) {
    return "gpt-image-2";
  }
  return "nano-banana-pro";
}
export type PreviousImagesMode = "none" | "upload";
export type ImageSize = "1K" | "2K" | "4K";
export type AspectRatio = "1:1" | "16:9" | "4:3";

export type ResearchDrawingFormValue = {
  userInput: string;
  modifyInstruction: string;
  researchDirection: string;
  imageModel: ImageModel;
  imageType: ImageType;
  previousImagesMode: PreviousImagesMode;
  previousImages: string[];
  imageSize: ImageSize;
  aspectRatio: AspectRatio;
  taskId?: number;
};

export type ImageGenerationRequest = {
  userInput: string;
  imageModel: ImageModel;
  researchDirection?: string;
  imageType: ImageType;
  imageSize: ImageSize;
  aspectRatio: AspectRatio;
  previousImages: string[];
  taskId?: number;
};

export type ImageGenerationTask = {
  taskId: number;
  status: -1 | 0 | 1 | 2;
  userInput: string;
  imageModel?: ImageModel;
  imageType: ImageType;
  previousImages: string[];
  researchDirection: string;
  imageSize: string;
  aspectRatio: string;
  beansCost: number;
  imageUrl: string;
  createTime: string;
  finishTime?: string | null;
};

export type ImageUploadResult = {
  url: string;
  filename: string;
};

export type ImageGenerationWsMessage =
  | {
    type: "task_created";
    data: {
      taskId: number;
      status: "created";
      beansCost: number;
      message: string;
    };
  }
  | {
    type: "task_status";
    data: {
      taskId: number;
      status: "generating" | "saving";
      message: string;
    };
  }
  | {
    type: "task_result";
    data: {
      taskId: number;
      imageUrl: string;
	      imageSize: ImageSize | string;
	      aspectRatio: AspectRatio | string;
	      beansCost: number;
	      imageType?: ImageType | string;
	      researchDirection?: string;
	    };
	  }
  | {
    type: "error";
    data: {
      taskId?: number;
      code?: number;
      message: string;
    };
  }
  | {
    type: "done";
    data?: undefined;
  };
